/*=========================================================================================
  File Name: usersActions.js
  Description: Vuex Store - users actions
==========================================================================================*/

import axios from 'axios';
import state from '../state';

export default {
    /**
     *
     * @param commit
     * @returns {Promise<unknown>}
     */
    getSources({commit}) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/source', method: 'GET'})
                .then(({data}) => {
                    commit('SET_PERMISSIONS', data.permissions);
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },

    /**
     *
     * @param commit
     * @param payload
     * @returns {Promise<unknown>}
     */
    storeSource({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/source/store', data: payload, method: 'POST'})
                .then(({data}) => {
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },

    /**
     *
     * @param commit
     * @param payload
     * @returns {Promise<unknown>}
     */
    updateSource({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/source/update', data: payload, method: 'POST'})
                .then(({data}) => {
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },

    /**
     *
     * @param commit
     * @param id
     * @returns {Promise<unknown>}
     */
    deleteSource({commit}, id) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/source/delete/' + id, method: 'DELETE'})
                .then(({data}) => {
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },

    getSourceOptions({commit}) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/source/options', method: 'GET'})
                .then(({data}) => {
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },
};
